module.exports = __webpack_public_path__ + "static/media/2025-04-29-01.9ae1bb2f.jpg";